import React from 'react';

function ConstructionContent() {
  return (
    <>
      <style dangerouslySetInnerHTML={{__html: `
        .tc-construction-content {
          position: relative;
          padding: 120px 0;
          background: #fff;
          overflow: hidden;
        }
        .construction-content-wrapper {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 80px;
          align-items: center;
        }
        .construction-text {
          position: relative;
        }
        .construction-subtitle {
          color: #73bf44;
          font-size: 14px;
          font-weight: 600;
          letter-spacing: 2px;
          text-transform: uppercase;
          margin-bottom: 20px;
          display: inline-block;
          padding: 8px 20px;
          background: rgba(115, 191, 68, 0.1);
          border-radius: 30px;
          border: 1px solid rgba(115, 191, 68, 0.2);
        }
        .construction-title {
          font-size: 48px;
          font-weight: 700;
          color: #1a1a1a;
          margin-bottom: 40px;
          line-height: 1.3;
          letter-spacing: -0.5px;
        }
        .construction-description {
          color: #666;
          font-size: 16px;
          line-height: 1.8;
          margin-bottom: 30px;
        }
        .construction-description strong {
          color: #1a1a1a;
          font-weight: 700;
        }
        .construction-image {
          position: relative;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
        }
        .construction-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        @media (max-width: 991px) {
          .tc-construction-content {
            padding: 80px 0;
          }
          .construction-content-wrapper {
            grid-template-columns: 1fr;
            gap: 50px;
          }
          .construction-title {
            font-size: 36px;
          }
          .construction-image {
            order: -1;
          }
        }
        @media (max-width: 767px) {
          .tc-construction-content {
            padding: 60px 0;
          }
          .construction-content-wrapper {
            gap: 40px;
          }
          .construction-subtitle {
            font-size: 12px;
            padding: 6px 16px;
          }
          .construction-title {
            font-size: 32px;
            margin-bottom: 30px;
          }
          .construction-description {
            font-size: 15px;
            margin-bottom: 25px;
          }
        }
        @media (max-width: 575px) {
          .construction-title {
            font-size: 28px;
          }
          .construction-description {
            font-size: 14px;
          }
        }
      `}} />
      <section className="tc-construction-content">
        {/* Blurred circular gradient backgrounds */}
        <div 
          className="d-none d-md-block"
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: 'clamp(300px, 35vw, 500px)',
            height: 'clamp(180px, 25vh, 300px)',
            background: 'rgba(115, 191, 68, 0.2)',
            filter: 'blur(60px)',
            borderRadius: '500px',
            pointerEvents: 'none',
            zIndex: 0
          }}
        />
        <div 
          className="d-none d-md-block"
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: 'clamp(250px, 28vw, 400px)',
            height: 'clamp(250px, 28vw, 400px)',
            background: 'rgba(115, 191, 68, 0.15)',
            filter: 'blur(60px)',
            borderRadius: '350px',
            pointerEvents: 'none',
            zIndex: 0
          }}
        />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="construction-content-wrapper">
            <div className="construction-text">
              <div className="construction-subtitle">[ WHAT WE OFFER ]</div>
              <h4 style={{ fontSize: '34px', fontWeight: '600', color: '#1a1a1a', marginBottom: '20px', lineHeight: '1.3', letterSpacing: '-0.5px' }}>
                Turning Construction Challenges into Successful Results
              </h4>
              <div className="construction-description" style={{ fontWeight: '500', color: '#333' }}>
                Delivering high-quality construction services with precision, safety, and excellence.
              </div>
              <div className="construction-description">
                We help clients achieve the results they envisioned—especially when construction projects fall short due to poor coordination, design gaps, execution errors, or repeated on-site mistakes.
              </div>
              <div className="construction-description">
                Construction is more than assembling materials; it is a carefully managed process that transforms ideas into lasting structures. From planning and design to execution and completion, successful construction demands precision, experience, and seamless collaboration between architects, engineers, project managers, contractors, and skilled labor. When any part of this chain fails, projects face delays, cost overruns, and compromised quality.
              </div>
              <div className="construction-description">
                Many clients struggle with miscommunication, design inconsistencies, unskilled workmanship, and avoidable errors on site. Our role is to step in with clarity and control—streamlining workflows, resolving design-to-construction gaps, and ensuring that every decision is executed accurately on the ground.
              </div>
              <div className="construction-description">
                We leverage modern construction technologies such as Building Information Modeling (BIM), drones, virtual reality (VR), smart construction tools, and advanced project management systems to reduce errors, improve coordination, and increase efficiency. These tools allow us to identify problems before they occur, minimize rework, and maintain strict quality standards throughout the project lifecycle.
              </div>
              <div className="construction-description">
                Construction plays a vital role in shaping the built environment—from homes and commercial spaces to complex infrastructure. By prioritizing safety, accuracy, sustainability, and accountability, we help deliver projects that are not only functional and durable, but also aligned with the original vision and expectations of our clients.
              </div>
            </div>
            <div className="construction-image">
              <img
                src="/home_preview/assets/img/Architecture_Deisgn/5880.FahadResidence-Lahore/LightTest-1(1).jpg"
                alt="Construction Building"
                className="img-cover"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ConstructionContent;

